import api from "../../Api/feathers-client";

// Call backend service to update defs
export const createDefs = async (data, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("defs").create(data, params);
      resolve({
        status: 200,
        message: "Created Defs",
        data: response,
      });
    } catch (error) {
      //console.log("error",error);
      resolve(error);
    }
  });
};

// Call backend service to update defs
export const updateDefs = async (data, uid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("defs").patch(null, data, {
        query: {
          uid,
          site_uuid,
        },
      });
      resolve({
        status: 200,
        message: "Defs Updated",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const checkLearnerInClass = async (classId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let res = await api.service("users").find({
        query: {
          belongs_to: classId,
          $limit: 0,
        },
      });
      resolve({
        status: 200,
        message: "check learner in class",
        total: res.total,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to update defs
export const getDefs = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("defs").find({
        query: params,
      });
      resolve({
        status: 200,
        message: "Defs Updated",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
